import { render, staticRenderFns } from "./ActivityDeta.vue?vue&type=template&id=920e06d8&scoped=true"
import script from "./ActivityDeta.vue?vue&type=script&lang=js"
export * from "./ActivityDeta.vue?vue&type=script&lang=js"
import style0 from "./ActivityDeta.vue?vue&type=style&index=0&id=920e06d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920e06d8",
  null
  
)

export default component.exports